import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { AppLink, routeNaming } from '../../routes';

import { constants } from '../../config';
import { SecondaryButton } from '../../common/secondary-button';
import { IncrementalCheckoutSummary } from '../../common/incremental-checkout-summary';
import { CheckoutInvoice } from '../../common/checkout-invoice';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { Checkbox } from '../../common/checkbox';
import { ScreenStore } from '../../stores/ScreenStore';
import { ErrorModal } from './error-modal';
import { calculateCartItemAmount, getDebitCartTax } from '../../helpers/CartHelper';
import styles from './ConfirmCheckout.css';
import { Product } from '../../models/Product';
import { InfoModal } from '../../common/info-modal';
import { Spinner } from '../../common/spinner';
import { ModalSweet } from '../../common/modal-sweet';
import { UserAgentHelper } from '../../helpers/UserAgentHelper';
import { ConfigParametersStore } from '../../stores/ConfigParametersStore';

const IPropTypes = {
  onSubmit: PropTypes.func,
};

const defaultProps = {
  onSubmit: () => { },
};

class ConfirmCheckout extends React.Component {
  constructor(props) {
    super(props);
    let futureDate = null;
    if (CheckoutStore.selectedOption && CheckoutStore.selectedOption.futureDate) {
      // eslint-disable-next-line prefer-destructuring
      futureDate = CheckoutStore.selectedOption.futureDate;
    }
    if (!futureDate && CheckoutStore.selectedTimeSlot) {
      // eslint-disable-next-line prefer-destructuring
      futureDate = CheckoutStore.selectedTimeSlot.futureDate;
    }
    this.state = {
      additionalNotes: null,
      validationNotes: true,
      acceptTermsAndConditions: false,
      paramsBank: null,
      error: null,
      isIphoneModalOpen: CheckoutStore.bank
        && CheckoutStore.bank.id === 218 && (UserAgentHelper.isIphone()),
      futureDate,
    };
    this.buttonBank = React.createRef();
    this._onAdditionalNotesEdit = this._onAdditionalNotesEdit.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._toggleAcceptTermsAndConditions = this._toggleAcceptTermsAndConditions.bind(this);
    this._dataIsValid = this._dataIsValid.bind(this);
    this._needShowModal = this._needShowModal.bind(this);
    this._getSistarbancUrl = this._getSistarbancUrl.bind(this);
  }

  _needShowModal() {
    return constants.activeCovid &&
      CheckoutStore.checkoutCart.toJS().some(item => new Product(item.product).serviceProduct);
  }

  _onAdditionalNotesEdit(event) {
    const { target: { value } } = event;
    this.setState({
      additionalNotes: value,
      validationNotes: value.length < 200,
    });
  }

  _dataIsValid() {
    const hasDebitCartTax = getDebitCartTax(CheckoutStore.checkoutCart);
    const acceptedTerms = this.state.acceptTermsAndConditions;
    if (CheckoutStore.paymentType && CheckoutStore.paymentType.id === 4 && localStorage.getItem('add-debit-card') && localStorage.getItem('add-debit-card') === '1') {
      return hasDebitCartTax && acceptedTerms;
    }
    return acceptedTerms;
  }

  async _onSubmit() {
    this.setState({ isIphoneModalOpen: false });
    if (!this._dataIsValid()) {
      return;
    }
    try {
      let notes = this.state.additionalNotes;
      if (this.state.futureDate) {
        notes =
          JSON.stringify({ m: this.state.additionalNotes, futureDate: `${this.state.futureDate.year}-${this.state.futureDate.month}-${this.state.futureDate.day}` });
      }
      await this.props.onSubmit(notes);
      if (CheckoutStore.finishedCheckout.requestBank) {
        this.setState({
          paramsBank: CheckoutStore.finishedCheckout.requestBank,
        }, () => {
          if (this.state.paramsBank && this.buttonBank && this.buttonBank.current) {
            this.buttonBank.current.click();
            localStorage.setItem('last_transaction_bank', this.state.paramsBank.idTransaccion);
          } else {
            this.setState({ error: 'No se ha podido efectuar el pago utilizando esta forma de pago' });
          }
        });
      }
    } catch (error) {
      this.setState({ error: 'No se ha podido efectuar el pago' });
    }
  }

  _toggleAcceptTermsAndConditions() {
    this.setState(prevState => ({
      acceptTermsAndConditions: !prevState.acceptTermsAndConditions,
    }));
  }

  _getSistarbancUrl() {
    return ConfigParametersStore.isFeatureFlagEnabled('sistarbanc_pay_without_fee') ? process.env.REACT_APP_SISTARBANK_URL_WITHOUT_FEE : process.env.REACT_APP_SISTARBANK_URL_WITH_FEE;
  }

  render() {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>
          Confirmar pedido
        </h1>
        { CheckoutStore.creationLoading &&
          <Spinner className={styles.spinner} />
        }
        {
          CheckoutStore.creationError &&
          <ErrorModal />
        }
        <div className={styles.confirmBox}>
          <div className={styles.confirmText}>
            <p className={styles.text}>
              Revise los datos de su pedido a continuación
            </p>
            <p className={styles.totalPrice}>
              Total ${CheckoutStore.fullPriceString}
            </p>
          </div>
          <InfoModal
            showModal={this._needShowModal()}
            id="servicio-instalación-covid"
            type="button-with-action"
            actionConfirm={this._onSubmit}
          >
            <SecondaryButton
              className={styles.confirmButton}
              disabled={!this._dataIsValid() || CheckoutStore.creationLoading}
            >
              {
                CheckoutStore.creationLoading ? 'Cargando' : 'Confirmar Pedido'
              }
            </SecondaryButton>
          </InfoModal>
        </div>
        <div className={styles.mainContent}>
          <div className={styles.leftContainer}>
            <IncrementalCheckoutSummary onlyProductData />
            <CheckoutInvoice
              cart={CheckoutStore.checkoutCart}
              productAmount={calculateCartItemAmount(CheckoutStore.checkoutCart)}
              totalProductPrice={CheckoutStore.checkoutCartTotalPrice}
              totalPrice={CheckoutStore.fullPrice}
              shippingPrice={CheckoutStore.selectedOption && CheckoutStore.selectedOption.price}
              extraShippingCost={CheckoutStore.selectedAgency &&
              CheckoutStore.selectedAgency.extraCost}
            />
            {
              ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth &&
              <IncrementalCheckoutSummary minimalInfo />
            }
            <div className={styles.textareaContainer}>
              <div>
                <label className={styles.label}>
                  Notas adicionales
                </label>
              </div>
              <textarea
                maxLength="200"
                className={styles.textarea}
                onChange={this._onAdditionalNotesEdit}
              />
              {
                !this.state.validationNotes &&
                <p className={styles.error}>
                  La nota no debe tener más de 200 caracteres.
                </p>
              }
            </div>
            <div className={styles.checkboxContainer}>
              <Checkbox
                checked={this.state.acceptTermsAndConditions}
                className={styles.acceptTermsAndConditionsCheckbox}
                onClick={this._toggleAcceptTermsAndConditions}
              />
              <AppLink
                className={styles.termsAndConditionsLink}
                routeName={routeNaming.CONDITIONS}
                queryParams={{ type: 'checkout' }}
                targetBlank
              >
                Acepto los Términos y Condiciones
              </AppLink>
            </div>
          </div>
          {
            ScreenStore.screenWidth > constants.breakpoints.extraSmallMaxWidth &&
            <div className={styles.rightContainer}>
              <IncrementalCheckoutSummary minimalInfo />
            </div>
          }
        </div>
        <div className={styles.buttonContainer}>
          {
            this.state.error &&
            <p className={styles.error}>
              {this.state.error}
            </p>
          }
          <InfoModal
            showModal={this._needShowModal()}
            id="servicio-instalación-covid"
            type="button-with-action"
            actionConfirm={this._onSubmit}
          >
            <SecondaryButton
              className={styles.confirmButton}
              disabled={!this._dataIsValid() || CheckoutStore.creationLoading}
            >
              {
                CheckoutStore.creationLoading ? 'Cargando' : 'Confirmar Pedido'
              }
            </SecondaryButton>
          </InfoModal>
        </div>
        <ModalSweet
          isOpen={this.state.isIphoneModalOpen && false}
          title="Pago con Santander desde iPhone"
          confirmCallback={() => this.setState({ isIphoneModalOpen: false })}
        >
          <p>
            Aviso: Sitúa tu celular en posición horizontal para ingresar tu contraseña en Santander.
          </p>
        </ModalSweet>
        {this.state.paramsBank &&
          <form method="POST" action={this._getSistarbancUrl()}>
            <input type="hidden" name="idBanco" value={this.state.paramsBank.idBanco} />
            <input type="hidden" name="idTransaccion" value={this.state.paramsBank.idTransaccion} />
            <input type="hidden" name="idOrganismo" value={this.state.paramsBank.idOrganismo} />
            <input type="hidden" name="tipoServicio" value={this.state.paramsBank.tipoServicio} />
            <input type="hidden" name="idCuenta" value={this.state.paramsBank.idCuenta} />
            <input type="hidden" name="idFactura" value={this.state.paramsBank.idFactura} />
            <input type="hidden" name="importe" value={this.state.paramsBank.importe} />
            <input type="hidden" name="importeGravado" value={this.state.paramsBank.importeGravado} />
            <input type="hidden" name="consumidorFinal" value={this.state.paramsBank.consumidorFinal} />
            <input type="hidden" name="moneda" value={this.state.paramsBank.moneda} />
            <input type="hidden" name="urlVuelta" value={process.env.REACT_APP_GOBACK_URL} />
            <input ref={this.buttonBank} type="submit" value="Enviar" style={{ opacity: 0 }} />
          </form>
        }
      </div>
    );
  }
}

ConfirmCheckout.propTypes = IPropTypes;
ConfirmCheckout.defaultProps = defaultProps;

const ObservedConfirmCheckout = observer(ConfirmCheckout);

export { ObservedConfirmCheckout as ConfirmCheckout };



// WEBPACK FOOTER //
// ./src/pages/confirm-checkout/ConfirmCheckout.jsx